export default [
    // 직원현황
    {
        path: '/mng/MembStat',
        name: 'MembStat',
        component: () => import('@/views/memb/mng/MembStat.vue')
    },
    // 직원상세
    {
        path: '/mng/MembDetl',
        name: 'MembDetl',
        component: () => import('@/views/memb/mng/MembDetl.vue')
    }
]